import React, { useState } from "react";
import "./eventWrapper.scss";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import moment from "moment";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { Stack } from "react-bootstrap";
import { isEmpty } from "../../../../utils/validation";

function formatDateRange(startDatetime, endDatetime) {
  // Usa moment per creare gli oggetti Date
  const startDate = moment(startDatetime, "YYYY/MM/DD HH:mm");
  const endDate = moment(endDatetime, "YYYY/MM/DD HH:mm");

  // Se la startDatetime e la endDatetime sono uguali
  if (startDate.format("YYYY/MM/DD" === endDate.format("YYYY/MM/DD"))) {
    return startDate.format("HH:mm") + " - " + endDate.format("HH:mm");
  } else {
    return startDatetime + " - " + endDatetime;
  }
}

const EventWrapper = ({
  idEvent,
  eventName,
  associationName,
  address,
  startDatetime,
  endDatetime,
  shifts,
}) => {
  return (
    <div className="single-shift-container">
      <div className="left-column">
        <span className="hour">
          {/*to do che il mi prendo data e ora con moment */}
          {startDatetime.split(" ")[1] ?? null}
        </span>
      </div>
      <div className="right-column">
        <hr />
        <EventBox
          eventName={eventName}
          idEvent={idEvent}
          address={address}
          associationName={associationName}
          startDatetime={startDatetime}
          endDatetime={endDatetime}
          shifts={shifts}
        />
      </div>
    </div>
  );
};

const EventBox = ({
  idEvent,
  eventName,
  associationName,
  address,
  startDatetime,
  endDatetime,
  shifts,
}) => {
  const [showMore, setShowMore] = useState(true);

  const navigate = useNavigate();

  return (
    <div className="wrapper-event-box">
      <Stack gap={0}>
        <span
          onClick={() => navigate("/event/" + idEvent)}
          className="event-name"
        >
          {eventName.toUpperCase()}
        </span>
        <span className="name-association">
          {t("calendar.association").toUpperCase()} {associationName}
        </span>
        <span className="address">{address}</span>
        <span className="interval-hour">
          {formatDateRange(startDatetime, endDatetime)}
        </span>
        {showMore ? (
          <Stack
            className="mt-2"
            gap={2}
            onClick={() => navigate("/event/" + idEvent)}
          >
            {!isEmpty(shifts)
              ? shifts.map((item) => (
                  <ShiftBox
                    key={item.id}
                    idShift={item.id}
                    title={item.title}
                    description={item.description}
                    color={item.color}
                    startDatetime={item.start_datetime}
                    endDatetime={item.end_datetime}
                  />
                ))
              : null}
          </Stack>
        ) : null}

        {!isEmpty(shifts) ? (
          <div className="expand-icon" onClick={() => setShowMore(!showMore)}>
            {showMore ? (
              <KeyboardArrowUpIcon sx={{ width: 20, height: 20 }} />
            ) : (
              <KeyboardArrowDownIcon sx={{ width: 20, height: 20 }} />
            )}
          </div>
        ) : null}
      </Stack>
    </div>
  );
};

const ShiftBox = ({
  idShift,
  title,
  description,
  startDatetime,
  endDatetime,
  color,
}) => {
  return (
    <Stack
      className="shift-box-container"
      style={{ backgroundColor: color }}
      gap={0}
    >
      <Stack gap={0}>
        <span className="title">{title.toUpperCase()}</span>
        <p className="description">{description}</p>
      </Stack>
      <span className="interval-hour">
        {formatDateRange(startDatetime, endDatetime)}
      </span>
    </Stack>
  );
};

export default EventWrapper;
